import { render, staticRenderFns } from "./GestioneModuliMenu.vue?vue&type=template&id=e1f6f766&scoped=true&"
import script from "./GestioneModuliMenu.vue?vue&type=script&lang=js&"
export * from "./GestioneModuliMenu.vue?vue&type=script&lang=js&"
import style0 from "./GestioneModuliMenu.vue?vue&type=style&index=0&id=e1f6f766&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f6f766",
  null
  
)

export default component.exports